<template>
    <main-layout>
        <template #submenu>
            <helm-chart-sub-menu :team="team" :chart="chart" active="settings"></helm-chart-sub-menu>
        </template>

        <template #pageTitle>
            <h2 class="mb-1">
                <span>Helm Chart Settings</span>
                <span>{{team.slug}}</span> /
                <span>{{chart.chart_name}}</span>
            </h2>
            <span class="sm-text">Manage '{{ chart.chart_name }}' helm chart here</span>
        </template>

        <div class="panel-wrap">
            <div class="title-col2 text-left">
                <h2>Advanced</h2>
            </div>
            <div class="panel-body" v-if="false">
                <div class="row g-2 align-items-center">
                    <div class="col-md">
                        <div class="panel-style">
                            <h4>Move helm chart</h4>
                            <p>Moving helm chart is a dangerous operation. One helm chart moved all the external
                                references of this chart must be updated</p>
                        </div>
                    </div>
                    <div class="col-md-auto">
                        <div class="panel-btn">
                            <button type="button" name="button" class="btn btn-style btn-primary">
                                <span>Move Chart</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel-body" v-if="false">
                <div class="row g-2 align-items-center">
                    <div class="col-md">
                        <div class="panel-style">
                            <h4>Rename helm chart</h4>
                            <p>Renaming chart is a dangerous operation. Helm charts installed before renaming will not
                                switch to
                                the new location automatically. It is recommended to create a copy of a chart with a new
                                name and keep old one archived</p>
                        </div>
                    </div>
                    <div class="col-md-auto">
                        <div class="panel-btn">
                            <button type="button" name="button" class="btn btn-style btn-primary">
                                <span>Rename Chart</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel-body" v-if="false">
                <div class="row g-2 align-items-center">
                    <div class="col-md">
                        <div class="panel-style">
                            <h4>Archive chart</h4>
                            <p>Chart will remain available but readonly. No new versions of the chart will be published.
                                Integrations with the
                                git repository will be suspended.</p>
                        </div>
                    </div>
                    <div class="col-md-auto">
                        <div class="panel-btn">
                            <button type="button" name="button" class="btn btn-style btn-primary">
                                <span>Archive Chart</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <div class="row g-2 align-items-center">
                    <div class="col-md">
                        <div class="panel-style">
                            <h4>Delete Chart</h4>
                            <p>This operation is irreversible, chart will become unavailable immediatelly after
                                deletion. You may re-upload same chart name in the future.</p>
                        </div>
                    </div>
                    <div class="col-md-auto">
                        <div class="panel-btn">
                            <button type="button" name="button" class="btn btn-style btn-danger">
                                <span>Delete Chart</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main-layout>
</template>

<script>
    import MainLayout from "@/Layouts/MainLayout";
    import HelmChartSubMenu from "@/Components/HelmChartSubMenu";

    export default {
        name: "Settings",
        components: {HelmChartSubMenu, MainLayout},
        props: ['team', 'chart'],

        data() {
            return {
                deleteHelmChartForm: this.$inertia.form({})
            }
        },
        methods: {
            submitDeleteForm: () => {

            }
        }
    }
</script>

<style scoped>

</style>
